module.exports = {"formatVersion":3,"id":"root","ideas":{"1":{"title":"Press Space or double-click to edit","id":1,"attr":{"position":[-79,-24,1]}}},"title":""}


//////////////////
// WEBPACK FOOTER
// ./src/example-map.json
// module id = 19
// module chunks = 0